// based on rc-trigger 5.2.10
import Trigger from './Trigger';
import { triggerProps } from './interface';
export { triggerProps };
export default Trigger;
